import i18next from 'i18next'
import {
  loadedAsyncState,
  loadingAsyncState,
  unloadedAsyncState,
} from 'widgets-for-react'
import { TypeCastingValidator, canSafelyCast } from '../../../utils/safe-type-casting'
import { loadBlogTeasers } from '../blogs/blogTeasers/blogTeasersApi'
import {
  getComponentTeasers,
  loadComponentTeasers,
} from '../components/componentTeasers/componentTeasersApi'
import { initialDishHighlightState } from '../dishes/dishHighlight/dishHighlightState'
import { initialGuestChefHightlightState } from '../guestChef/guestChefHighLight/guestChefHighLight.state'
import { initialKnowledgeHighlightState } from '../knowledge/knowledgeHighlight/knowledgeHighlightState'
import { HomeData } from './home.state'
import { getBlogTeasers } from './loggedOutHome/loggedOutHomeApi'

async function getHomeData(): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const res = await fetch(`/api/v1/homepage?language=${i18next.language}`, {
    method: 'get',
    headers: headers,
  })

  if (!res.ok) throw Error(res.statusText)

  const fields = await res.json()

  return {
    blogIds: fields.blogIds || [],
    componentIds: fields.componentIds || [],
    highlightedDishId: fields.highlightedDishId || -1,
    highlightedKnowledgeId: fields.highlightedKnowledgeId || -1,
    guestChefId: fields.guestChefId || -1,
  }
}

type HomeApiData = {
  blogIds: number[]
  componentIds: number[]
  highlightedDishId: number
  highlightedKnowledgeId: number
  guestChefId: number
}

const homeApiDataValidator: TypeCastingValidator<HomeApiData> = {
  kind: 'object',
  fieldsValidator: {
    blogIds: { kind: 'array', elementValidator: { kind: 'number' } },
    componentIds: { kind: 'array', elementValidator: { kind: 'number' } },
    highlightedDishId: { kind: 'number' },
    highlightedKnowledgeId: { kind: 'number' },
    guestChefId: { kind: 'number' },
  },
}

export const loadHomeData = loadingAsyncState<HomeData>(() =>
  getHomeData().then((raw) => {
    const maybeHomeData = canSafelyCast<HomeApiData>(homeApiDataValidator, raw)
    if (maybeHomeData.kind == 'r') {
      const homeData = maybeHomeData.v
      const filterIds = (ids: number[]) =>
        ids
          .map((id) => (id ? [id] : []))
          .reduce((prev, current) => prev.concat(current), [])
      const componentTeaserIds = filterIds(homeData.componentIds)
      const blogTeaserIds = filterIds(homeData.blogIds)
      return {
        kind: 'result',
        value: {
          componentTeasers:
            componentTeaserIds.length > 0
              ? loadComponentTeasers(() =>
                  getComponentTeasers(componentTeaserIds)
                )
              : loadedAsyncState([]),
          blogTeasers:
            blogTeaserIds.length > 0
              ? loadBlogTeasers(() => getBlogTeasers(blogTeaserIds))
              : loadedAsyncState([]),
          dishHighlight:
            homeData.highlightedDishId >= 0
              ? initialDishHighlightState(homeData.highlightedDishId)
              : unloadedAsyncState(),
          knowledgeHighlight:
            homeData.highlightedKnowledgeId >= 0
              ? initialKnowledgeHighlightState(homeData.highlightedKnowledgeId)
              : unloadedAsyncState(),
          guestChefHighlight:
            homeData.guestChefId >= 0
              ? initialGuestChefHightlightState(homeData.guestChefId)
              : unloadedAsyncState(),
        },
        status: 200,
      }
    } else return { kind: 'failed', status: 404 }
  })
)
